import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const ACTIVATION_STATUS = {
  APPROVED: {
    label: 'Approved',
    value: 'APPROVED',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  REJECTED: {
    label: 'Rejected',
    value: 'REJECTED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  PENDING_APPROVAL: {
    label: 'Pending Approval',
    value: 'PENDING_APPROVAL',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  NOT_UPLOADED: {
    label: 'Not Uploaded',
    value: 'NOT_UPLOADED',
    color: '#2A2A2A',
    bgColor: '#E8E8E8'
  },
  NOT_STARTED: {
    label: 'Not Started',
    value: 'NOT_STARTED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  }
};

const KYC_STATUS = {
  APPROVED: {
    label: 'Approved',
    value: 'APPROVED',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  REJECTED: {
    label: 'Rejected',
    value: 'REJECTED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  PENDING_APPROVAL: {
    label: 'Pending Approval',
    value: 'PENDING_APPROVAL',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  NOT_UPLOADED: {
    label: 'KYC In-Progress',
    value: 'NOT_UPLOADED',
    color: '#DDB40E',
    bgColor: '#FFF7D5'
  },
  NOT_STARTED: {
    label: 'Not Started',
    value: 'NOT_STARTED',
    color: '#2A2A2A',
    bgColor: '#E8E8E8'
  }
};

const MERCHANT_STATUS = {
  LIVE_MERCHANT: {
    label: 'Live Merchant',
    value: 'LIVE_MERCHANT',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  LIVE_NOT_ACTIVE: {
    label: 'Live Not-Active',
    value: 'LIVE_NOT_ACTIVE',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  INACTIVE_MERCHANTS: {
    label: 'Inactive Merchant',
    value: 'INACTIVE_MERCHANTS',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  PENDING_MERCHANTS: {
    label: 'Pending Merchant',
    value: 'PENDING_MERCHANTS',
    color: '#DDB40E',
    bgColor: '#FFF7D5'
  }
};

const LEAD_PRIORITY = {
  LOW: {
    label: 'Low',
    value: 'LOW',
    color: '#719DFF',
    bgColor: '#D8E4FF'
  },
  MEDIUM: {
    label: 'Medium',
    value: 'MEDIUM',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  HIGH: {
    label: 'High',
    value: 'HIGH',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  }
  // CRITICAL: {
  //   label: 'Critical',
  //   value: 'CRITICAL',
  //   color: '#DD0000',
  //   bgColor: '#FFE8E8'
  // }
};

const LEAD_STATUS = {
  NEW: {
    label: 'New',
    value: 'NEW',
    color: '#719DFF',
    bgColor: '#D8E4FF'
  },
  OPEN_NOT_CONTACTED: {
    label: 'Open - Not Contacted',
    value: 'OPEN_NOT_CONTACTED',
    bgColor: '#EBEBEB',
    color: '#7B7B7B'
  },
  CONTACTED: { label: 'CONTACTED', value: 'CONTACTED', bgColor: '#EBEBEB', color: '#7B7B7B' },
  WORKING: { label: 'Working', value: 'WORKING', bgColor: '#EBEBEB', color: '#7B7B7B' },
  PROSPECT: { label: 'Prospect', value: 'PROSPECT', bgColor: '#EBEBEB', color: '#7B7B7B' },
  UNQUALIFIED: { label: 'Unqualified', value: 'UNQUALIFIED', bgColor: '#EBEBEB', color: '#7B7B7B' }
};
const INVOICE_STATUS = {
  PARTNER_INVOICE_PENDING: {
    label: 'PARTNER_INVOICE_PENDING',
    color: 'yellow',
    tag: 'PENDING',
    render: (
      <Tooltip title="Invoice Pending">
        <ExclamationCircleOutlined style={{ color: '#eba212', fontSize: '150%' }} />
      </Tooltip>
    )
  },
  PARTNER_INVOICE_UPLOADED: {
    label: 'PARTNER_INVOICE_UPLOADED',
    tag: 'UPLOADED',
    color: 'green',
    render: (
      <Tooltip title="Invoice Uploaded">
        <CheckCircleOutlined style={{ color: '#00cc00', fontSize: '150%' }} />
      </Tooltip>
    )
  },
  ON_HOLD: {
    label: 'ON_HOLD',
    tag: 'Hold',
    color: 'red',
    render: (
      <Tooltip title="Invoice Rejected">
        <ExclamationCircleOutlined style={{ color: 'red', fontSize: '150%' }} />
      </Tooltip>
    )
  }
};
const GST_STATUS = {
  ON_HOLD: {
    label: 'ON HOLD',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  TO_BE_RELEASE: {
    label: 'TO BE RELEASE',
    color: '#719DFF',
    bgColor: '#D8E4FF'
  },
  RELEASED: {
    label: 'RELEASED',
    color: '#00E874',
    bgColor: '#E2FFF0'
  }
};
const PAYOUT_REPORT_STATUS = {
  PENDING: {
    label: 'PENDING',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  CALCULATING: {
    label: 'CALCULATING',
    color: '#719DFF',
    bgColor: '#D8E4FF'
  },
  FAIL: {
    label: 'FAIL',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  REJECTED: {
    label: 'REJECTED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  GENERATED: {
    label: 'GENERATED',
    color: '#00E874',
    bgColor: '#E2FFF0'
  },
  PARTNER_AWAITING: {
    label: 'APPROVAL PENDING',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  INVOICE_ON_HOLD: {
    label: 'INVOICE REJECTED',
    color: 'white',
    bgColor: '#fc9797'
  },
  PARTNER_APPROVED: {
    label: 'ACCEPTED',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  DISPUTED: {
    label: 'DISPUTED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  CANCELLED: {
    label: 'CANCELLED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  PROCESSING: {
    label: 'PROCESSING',
    color: '#00E874',
    bgColor: '#E2FFF0'
  },
  PAID: {
    label: 'PAID',
    color: '#0A9305',
    bgColor: '#EDFFED'
  }
};

const CUSTOM_REPORT_STATUS = {
  SUCCESS: {
    label: 'Success',
    value: 'SUCCESS',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  INPROGRESS: {
    label: 'In-Progress',
    value: 'INPROGRESS',
    color: '#DDB40E',
    bgColor: '#FFF7D5'
  },
  REQUESTED: {
    label: 'Requested',
    value: 'REQUESTED',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  FAILED: {
    label: 'Failed',
    value: 'FAILED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  }
};

const CUSTOM_REPORT_TRANSACTION_STATUS = {
  SUCCESS: {
    label: 'Success',
    value: 'SUCCESS',
    color: '#0A9305',
    bgColor: '#EDFFED'
  },
  BOUNCED: {
    label: 'Bounced',
    value: 'BOUNCED',
    color: '#719DFF',
    bgColor: '#D8E4FF'
  },
  DROPPED: {
    label: 'Dropped',
    value: 'DROPPED',
    color: '#CE841E',
    bgColor: '#FDEBD3'
  },
  FAILED: {
    label: 'Failed',
    value: 'FAILED',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  QUEUED: {
    label: 'Queued',
    value: 'queued',
    color: '#00A3E0',
    bgColor: '#E5F6FD'
  },
  ON_HOLD: {
    label: 'On Hold',
    value: 'on_hold',
    color: '#FFA500',
    bgColor: '#FFF5E5'
  },
  CANCELLED: {
    label: 'Cancelled',
    value: 'cancelled',
    color: '#B00020',
    bgColor: '#FFE6E9'
  },
  PENDING: {
    label: 'Pending',
    value: 'pending',
    color: '#FF9900',
    bgColor: '#FFF4E0'
  },
  ACCEPTED: {
    label: 'Accepted',
    value: 'accepted',
    color: '#0A66C2',
    bgColor: '#E6F0FF'
  },
  FAILURE: {
    label: 'Failure',
    value: 'failure',
    color: '#DD0000',
    bgColor: '#FFE8E8'
  },
  IN_PROCESS: {
    label: 'In Process',
    value: 'in_process',
    color: '#0066FF',
    bgColor: '#E0ECFF'
  },
  REJECTED: {
    label: 'Rejected',
    value: 'rejected',
    color: '#FF4D4F',
    bgColor: '#FFF1F0'
  },
  REVERSED: {
    label: 'Reversed',
    value: 'reversed',
    color: '#800080',
    bgColor: '#F3E8FD'
  },
  UNAPPROVED: {
    label: 'Unapproved',
    value: 'unapproved',
    color: '#A52A2A',
    bgColor: '#FAE3E3'
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
    color: '#1E90FF',
    bgColor: '#E0F3FF'
  },
  UNSETTLED: {
    label: 'Unsettled',
    value: 'Unsettled',
    color: '#8B0000',
    bgColor: '#FCE6E6'
  },
  RECEIVED: {
    label: 'Received',
    value: 'Received',
    color: '#228B22',
    bgColor: '#E5F9E5'
  },
  REFUNDED: {
    label: 'Refunded',
    value: 'Refunded',
    color: '#5C5CFF',
    bgColor: '#EAEAFF'
  },
  PARTIALLY_REFUNDED: {
    label: 'Partially Refunded',
    value: 'Partially Refunded',
    color: '#FF8C00',
    bgColor: '#FFF4DE'
  },
  TIME_OUT: {
    label: 'Timed Out',
    value: 'Timed Out',
    color: '#8B4513',
    bgColor: '#FFF3E0'
  },
  UNCAPUTRED: {
    label: 'Uncaptured',
    value: 'Uncaptured',
    color: '#6B5B95',
    bgColor: '#F0E6FF'
  }
};

export const CUSTOM_REPORT_TRANSFER_STATUS = [
  {
    label: 'Queued',
    value: 'QUEUED'
  },
  {
    label: 'On Hold',
    value: 'ON_HOLD'
  },
  {
    label: 'Cancelled',
    value: 'CANCELLED'
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Accepted',
    value: 'ACCEPTED'
  },
  {
    label: 'Failure',
    value: 'FAILURE'
  },
  {
    label: 'In Process',
    value: 'IN_PROCESS'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Reversed',
    value: 'REVERSED'
  },
  {
    label: 'Success',
    value: 'SUCCESS'
  },
  {
    label: 'Unapproved',
    value: 'UNAPPROVED'
  },
  {
    label: 'Scheduled',
    value: 'SCHEDULED'
  }
];

export const CUSTOM_REPORT_INSTACOLLECT_TRANSACTION_STATUS = [
  {
    label: 'Unsettled',
    value: 'UNSETTLED'
  },
  {
    label: 'Received',
    value: 'RECEIVED'
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Refunded',
    value: 'REFUNDED'
  },
  {
    label: 'Failure',
    value: 'FAILURE'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Partially Refunded',
    value: 'PARTIALLY_REFUNDED'
  },
  {
    label: 'Timed Out',
    value: 'TIME_OUT'
  },
  {
    label: 'Uncaptured',
    value: 'UNCAPUTRED'
  }
];

const INVOICE_ON_HOLD_REASON_DICT = {
  BACK_DATED_INVOICE: 'Back Dated Invoice',
  INVOICE_AMOUNT_MISMATCH: 'Invoice Amount MIsmatch',
  INVOICE_RECEIVED_INCLUDING_TAX: 'Invoice Received Including Tax',
  WRONG_MONTH_INVOICE: 'Wrong month invoice',
  GST_NOT_REFLECTED: 'Gst has not reflected'
};

export {
  GST_STATUS,
  INVOICE_STATUS,
  ACTIVATION_STATUS,
  KYC_STATUS,
  MERCHANT_STATUS,
  LEAD_PRIORITY,
  LEAD_STATUS,
  PAYOUT_REPORT_STATUS,
  CUSTOM_REPORT_STATUS,
  CUSTOM_REPORT_TRANSACTION_STATUS,
  INVOICE_ON_HOLD_REASON_DICT
};
